<template>
  <div v-if="showMinimalHint" class="row mb-3">
    <div class="col-12">
      <div class="card border-0 bg-light">
        <div class="card-body py-3">
          <p class="text-muted small mb-0">
            Use the shortcuts above or the sidebar for Documents, payslips, and
            other tools your employer has enabled for you.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useEmployeeDashboardAccess } from "@/composables/useEmployeeDashboardAccess";

const { showMinimalHint } = useEmployeeDashboardAccess();
</script>
